import axios from 'axios';

const simpleClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/v1`,
});

export default simpleClient;
